import React, {CSSProperties, FC, memo, useCallback, useEffect, useRef, useState} from "react";
import {Dropdown} from "react-bootstrap";
import {ContextMenuContainer, DropdownToggle} from "./ContextMenuStyle";
import {useDispatch} from "react-redux";
import {actions} from "../../store/sliceApp";
import {actions as modal} from "../../store/sliceModal";
import {deletePersons} from "../../fetch/RequestBirthday";
import {IPerson} from "../../store/slicePerson";

type ContextMenuBirthdayProps = {
    person: IPerson
    children: React.ReactElement
    style?: CSSProperties | undefined;
}

const ContextMenuBirthday: FC<ContextMenuBirthdayProps> = ({person, style, children}) => {

    const [open, setOpen] = useState(false);
    const dispatch = useDispatch()

    const ref = useRef<HTMLDivElement>(null)

    const [mousePos, setMousePos] = useState({ x: 0, y: 0 });


    let timer: NodeJS.Timer | undefined;

    useEffect(() => {
            const check = (e: any) => {
                if (open && ref.current && !ref.current.contains(e.target)) {
                    setOpen(false)
                    if (timer) {
                        clearInterval(timer)
                    }
                }
            }

            document.addEventListener("mousedown", check)
            // document.addEventListener("touchend", check)
            return () => {
                document.removeEventListener("mousedown", check)
                // document.removeEventListener("touchend", check)
            }
        }
        ,[open])

    useEffect(() => {
        const handleMouseMove = (event: { clientX: any; clientY: any; }) => {
            if (!open) {
                setMousePos({x: event.clientX, y: event.clientY});
            }
        };
        window.addEventListener('mousemove', handleMouseMove);
        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
        };
    },[open]);

    const contextMenuHandle = useCallback( (event: React.MouseEvent<HTMLDivElement>) => {
        event.stopPropagation()
        event.preventDefault()
        setOpen(true)
    },[])

    const onTouchStart = useCallback((event: React.TouchEvent<HTMLDivElement>) => {
        // @ts-ignore
        timer = setInterval(() => {
            setOpen(true)
            dispatch(actions.setContextBackground(true))
            clearInterval(timer)
        }, 800);
    }, [open, timer])

    const onTouchEnd = useCallback((event: React.TouchEvent<HTMLDivElement>) => {
        if (open) {
            event.stopPropagation()
            event.preventDefault()
        }
        clearInterval(timer)
    },[open, timer])

    const onTouchEndMenu = useCallback((event: React.TouchEvent<HTMLDivElement>) => {
        event.stopPropagation()
        event.preventDefault()
        clearInterval(timer)
        setOpen(false)
        dispatch(actions.setContextBackground(false))
    },[open, timer])

    const onClickCloseMenu = useCallback((event: React.MouseEvent<HTMLDivElement>) => {
        event.stopPropagation()
        event.preventDefault()
        setOpen(false)
    },[])


    const deleteMenuHandle = useCallback( (event: React.MouseEvent<HTMLDivElement>) => {
        if (person.id) {
            deletePersons(person.id)
        }
    },[open])

    const deleteMenuTouchHandle = useCallback( (event: React.TouchEvent<HTMLDivElement>) => {
        if (person.id) {
            deletePersons(person.id,)
        }
    },[open])

    const editMenuHandle = useCallback( (event: React.MouseEvent<HTMLDivElement>) => {
        dispatch(modal.showPersonModal(person))
    },[open])

    const editMenuTouchHandle = useCallback( (event: React.TouchEvent<HTMLDivElement>) => {
        dispatch(modal.showPersonModal(person))
    },[open])


    return (
        <ContextMenuContainer style={style} onContextMenu={contextMenuHandle} onTouchStart={onTouchStart} onTouchEnd={onTouchEnd}>
            {children}
            <Dropdown show={open} ref={ref} style={{height: 0, position: "absolute", left: `${mousePos.x}px`}}>
                <DropdownToggle/>
                <Dropdown.Menu onClick={onClickCloseMenu} onTouchEnd={onTouchEndMenu}>
                    <Dropdown.Item onClick={deleteMenuHandle} onTouchEnd={deleteMenuTouchHandle}>Удалить</Dropdown.Item>
                    <Dropdown.Item onClick={editMenuHandle} onTouchEnd={editMenuTouchHandle}>Редактировать</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        </ContextMenuContainer>
    )
}

export default memo(ContextMenuBirthday)
